<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <div class="row">
        <div class="col-sm-6">
            <h1 class="title-default">Configurar Relatório</h1>
        </div>
        <div class="col-sm-6 d-flex justify-content-end">
            <a type="button" mat-button class="btn-primary btn-add-right" routerLink="/inteligencia-dados/configurar-relatorio/cadastrar" *appTemPermissao="_PermissaoEnum.InteligenciaDados_ConfigurarRelatorio_Incluir">
                <mat-icon>add</mat-icon>
                Novo Relatório
            </a>    
        </div>
    </div> 

    <form class="form" [formGroup]="model"  (ngSubmit)="clickPesquisar()" class="search-area">
        <div class="d-flex justify-content-between">
            <div class="inputs">
                <mat-form-field appearance="outline">
                    <mat-label>Título relatório</mat-label>
                    <input matInput formControlName="tituloRelatorio" type="text">
                </mat-form-field>
            </div>

            <div class="inputs">
                <mat-form-field appearance="outline">
                    <mat-label>Perfil</mat-label> 
                    <mat-select formControlName="perfilAcesso" multiple>
                        @if(_usuarioLookupResponse){
                            @for (perfil of _usuarioLookupResponse.listaPerfil; track perfil) {
                                <mat-option [value]="perfil.idPerfil">{{ perfil.nome }}</mat-option>
                              }
                        }
                    </mat-select>
                </mat-form-field>
            </div>           

            <div class="col-md-auto">
                <button type="submit" mat-button class="btn-secundary" style="width: 140px;">
                    Pesquisar
                </button>
            </div>
        </div>
    </form>    

    @if(this._listaRelatorioResponse && this._listaRelatorioResponse.listaRelatorioPerfil.length > 0){
        <table mat-table [dataSource]="_listaRelatorioNomePerfil">
            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->
          
            <!-- Position Column -->
            <ng-container matColumnDef="idRelatorio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
                <td mat-cell *matCellDef="let element"> {{element.relatorio.idRelatorio}} </td>
            </ng-container>

            <ng-container matColumnDef="tituloRelatorio">
              <th mat-header-cell *matHeaderCellDef> Título Relatótio </th>
              <td mat-cell *matCellDef="let element"> {{element.relatorio.tituloRelatorio}} </td>
            </ng-container>

            <ng-container matColumnDef="perfilAcesso">
                <th mat-header-cell *matHeaderCellDef> Perfil com acesso </th>
                <td mat-cell *matCellDef="let element"> 
                    {{ element.listaPerfil | nomePerfil: _enumPerfil.Todos }}                 
                </td>
            </ng-container>

            <ng-container matColumnDef="action-edit">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element"> 
                    <a mat-mini-fab aria-label="Editar" class="fab-action default" [routerLink]="['/inteligencia-dados/configurar-relatorio/cadastrar/', {idRelatorio: element.relatorio.idRelatorio}]" *appTemPermissao="_PermissaoEnum.InteligenciaDados_ConfigurarRelatorio_Alterar">
                        <mat-icon>edit</mat-icon>
                    </a>
                </td>
            </ng-container>

            <ng-container matColumnDef="action-delete">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element"> 
                    <button type="button" mat-mini-fab aria-label="Excluir" class="fab-action default" (click)="abrirModalExcluir(element.relatorio.idRelatorio, element.relatorio.tituloRelatorio)" *appTemPermissao="_PermissaoEnum.InteligenciaDados_ConfigurarRelatorio_Excluir">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="col-12 text-center ver-mais-pesquisa">
            <button type="button" mat-button class="btn-primary" [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                    <span class="material-symbols-outlined">keyboard_arrow_down</span>
                    Ver mais
                }
            </button>
        </div>
    }@else if(_isLoading === true){
        <table>
            @for (item of [1,2,3]; track item) {
                <tr>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'110'" [marginTop]="'30'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'220'" [marginTop]="'30'" [marginLeft]="'50'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'320'" [marginTop]="'30'"  [marginLeft]="'50'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'100'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'20'"></app-loading-box>
                    </td>
                </tr>
            }
            
        </table>
    }
    @else if(this._listaRelatorioResponse?.listaRelatorioPerfil?.length === 0){
        <app-empty-list [title]="'Não foi encontrado nenhum relatório com o filtro informado'"></app-empty-list>
    }
</div>